import { useEffect, useRef } from "react";
import { Player, UIPlayerConfiguration } from "theoplayer";

import "/node_modules/theoplayer/ui.css";

export type PlayerCallback = (player: Player) => void;

interface Props {
    onPlayerCreated?: PlayerCallback | undefined;
    onPlayerDestroyed?: PlayerCallback | undefined;
    license: string;
}

export function THEOplayerView({ onPlayerCreated, license, onPlayerDestroyed }: Props) {
    const player = useRef<Player | null>(null);
    const container = useRef<null | HTMLDivElement>(null);

    useEffect(() => {
        // Create player inside container.
        if (container.current) {
            const config: UIPlayerConfiguration = {
                license,
                // Note: THEOplayer loads workers for transmuxing and other tasks
                // these workers need to be located on the same server (see npm run copy:theoplayer)
                libraryLocation: `${process.env.REACT_APP_BASE_URL}/vendor/theoplayer`,
                ui: {
                    fluid: true,
                },
                mutedAutoplay: "all",
                allowMixedContent: true,
            };
            player.current = new Player(container.current, config);
            // Notify the player is ready
            onPlayerCreated?.(player.current);
            function needsServiceWorkerForTHEOlive() {
                // @ts-ignore
                const canPlayMSE = !!(window.MediaSource || window.WebKitMediaSource || window.ManagedMediaSource);
                const videoElement = document.createElement("video");
                const canPlayHLS =
                    videoElement.canPlayType && videoElement.canPlayType("application/vnd.apple.mpegURL") !== "";
                return canPlayHLS && !canPlayMSE;
            }
            if (needsServiceWorkerForTHEOlive()) {
                navigator.serviceWorker.register(
                    `${process.env.REACT_APP_BASE_URL}/vendor/theoplayer/theoplayer.sw.js`,
                );
            }
        }

        // Clean-up
        return () => {
            // Notify the player will be destroyed.
            if (player?.current && onPlayerDestroyed) {
                onPlayerDestroyed(player?.current);
            }
            player?.current?.destroy();
        };
    }, [container, license, onPlayerCreated, onPlayerDestroyed]);

    return <div ref={container} className="theoplayer-container video-js theoplayer-skin vjs-16-9 THEOplayer" />;
}
